<template>
    <div class="global_deployment_container">
        <div class="global_deployment_gradient_1" v-lazy:background-image="require('@/assets/static/imgs/home/global-01.png')">
            <div class="global_deployment_gradient_2" v-lazy:background-image="require('@/assets/static/imgs/home/global-02.png')">
                <div class="global_deployment_gradient_3" v-lazy:background-image="require('@/assets/static/imgs/home/global-03.png')">
                    <div class="global_deployment_main">
                        <div class="global_deployment_title">{{ $t('index.global_deployment_title') }}</div>

                        <div class="global_deployment_desc">
                            <span>{{ $t('index.global_deployment_desc_0') }}</span>
                            <span>{{ $t('index.global_deployment_desc_1') }}</span>
                            <span>{{ $t('index.global_deployment_desc_2') }}</span>
                            <span>{{ $t('index.global_deployment_desc_3') }}</span>
                        </div>

                        <div class="cloud_area_box">
                            <div class="cloud_area_item">
                                <img v-lazy="showImgObj.aws_cloud" @error="handleError" alt="ICON" />
                                {{ $t('index.aws_cloud') }}
                            </div>
                            <div class="cloud_area_item">
                                <img v-lazy="showImgObj.google_cloud" @error="handleError" alt="ICON" />
                                {{ $t('index.google_cloud') }}
                            </div>
                            <div class="cloud_area_item">
                                <img v-lazy="showImgObj.aliyun_cloud" @error="handleError" alt="ICON" />
                                {{ $t('index.aliyun_cloud') }}
                            </div>
                        </div>

						<div class="circle_area">
							<div class="circle_pub circle_01"></div>
							<div class="circle_pub circle_02"></div>
							<div class="circle_pub circle_03"></div>
							<div class="circle_pub circle_04"></div>
							<div class="circle_pub circle_05"></div>
							<div class="circle_pub circle_06"></div>
							<div class="circle_pub circle_07"></div>
							<div class="circle_pub circle_08"></div>
							<div class="circle_pub circle_09"></div>
							<div class="circle_pub circle_10"></div>
							<div class="circle_pub circle_11"></div>
						</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GlobalDeploymentPc',
    data() {
        return {
            tips: 'Hello World',
            // Apply Sence 默认选中INDEX
			currentOpenMenuIndex: 0,
            showImgObj: {
				aliyun_cloud: require('@/assets/static/imgs/common/aliyun-cloud.png'),
				aws_cloud   : require('@/assets/static/imgs/common/aws-cloud.png'),
				google_cloud: require('@/assets/static/imgs/common/google-cloud.png')
			}
        }
    },
	methods: {
		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        }
	}
}
</script>

<style lang="less" scoped>
.global_deployment_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h3);
	background:linear-gradient(135deg, #3f0b9d, #13154d, #0f1142, #1e044e);
	.global_deployment_gradient_1{
		width:inherit;height:inherit;
		background-position:center top;
		background-repeat:no-repeat;
		background-size:1920px 320px;
		.global_deployment_gradient_2{
			width:inherit;height:inherit;
			background-position:center 320px;
			background-repeat:no-repeat;
			background-size:1920px 320px;
			.global_deployment_gradient_3{
				width:inherit;height:inherit;
				background-position:center 640px;
				background-repeat:no-repeat;
				background-size:1920px 320px;
				.global_deployment_main{
					position:relative;
					margin:0 auto;padding-top:75px;
					width:var(--com-base-container-w);height:inherit;
					.global_deployment_title{
						height:50px;line-height:50px;
						font-size:var(--com-base-fz-48);font-weight:bold;color:#FFF;text-align:center;
					}
					.global_deployment_desc{
						display:flex;justify-content:center;align-items:center;
						gap:60px;
						span{
							display:block;
							height:50px;line-height:60px;
							font-size:var(--com-base-fz-22);font-weight:normal;color:#7D7EA8;text-align:center;
						}
					}
					.cloud_area_box{
						position:absolute;left:0;right:0;bottom:50px;margin:auto;
						display:flex;justify-content:center;align-items:center;
						gap:30px;
						.cloud_area_item{
							width:240px;height:60px;
							border:2px solid rgba(255, 255, 255, .2);border-radius:18px;
							background:rgba(0, 0, 0, .2);
							font-size:var(--com-base-fz-22);color:#FFF;
							display:flex;justify-content:center;align-items:center;
							img{
								width:62px;height:62px;
								margin-right:3px;
							}
						}
					}
					.circle_area{
						width:inherit;height:inherit;
						position:absolute;top:0;right:0;bottom:0;left:0;
						.circle_pub{
							width:100px;height:100px;
							position:absolute;
							background:transparent;
						}
						.circle_pub::before, .circle_pub::after{
							display:block;content: '';
							width:10px;height:10px;
							border:4px solid rgba(255, 255, 255, .1);border-radius:50%;
							position:absolute;
							top:50%;left:50%;
							transform:translate(-50%, -50%);
							-webkit-transform:translate(-50%, -50%);
							will-change:width, height, opacity, border-width;
						}
						.circle_pub::before{
							animation:spread 12s linear infinite;
							-webkit-animation:spread 12s linear infinite;
						}
						.circle_pub::after{
							animation:spread 12s 5s linear infinite;
							-webkit-animation:spread 12s 5s linear infinite;
						}
						.circle_01{top:356px;left:229px;}
						.circle_02{top:491px;left:221px;}
						.circle_03{top:399px;left:364px;}
						.circle_04{top:540px;left:394px;}
						.circle_05{top:584px;left:473px;}
						.circle_06{top:478px;left:521px;}
						.circle_07{top:719px;left:648px;}
						.circle_08{top:455px;left:891px;}
						.circle_09{top:386px;left:976px;}
						.circle_10{top:463px;left:1033px;}
						.circle_11{top:671px;left:1110px;}
					}
				}
			}
		}
	}
}
@keyframes spread{
	0%{
		width:0px;height:0px;
		opacity:1;
		border-width:4px;
	}
	50%{
		width:75px;height:75px;
		opacity:.5;
		border-width:5px;
	}
	100%{
		width:150px;height:150px;
		opacity:0;
		border-width:6px;
	}
}
</style>